import { Box, Typography } from "@mui/material";
import React, { useState } from "react";

const IDCardViewer = ({ frontImage, backImage,documentNo,documentType }) => {
  // States for front and back images
  // const [frontImage, setFrontImage] = useState(
  //   "/assets/images/admin-panel/verification/id-verification.png"
  // ); // Default front image
  // const [backImage, setBackImage] = useState(
  //   "/assets/images/admin-panel/verification/id-verification-back.png"
  // ); // Default back image
  const [isFront, setIsFront] = useState(true); // Toggle state to show front or back

  // Handle image upload
  // const handleImageUpload = (event, isFrontImage) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const imageUrl = URL.createObjectURL(file); // Create a URL for the uploaded image
  //     if (isFrontImage) {
  //       setFrontImage(imageUrl); // Update front image
  //     } else {
  //       setBackImage(imageUrl); // Update back image
  //     }
  //   } else {
  //     alert("No file selected! Please try again."); // Alert if no file is selected
  //   }
  // };

  return (
    <div style={{ textAlign: "center" }}>
      {/* Display the image (front or back based on toggle) */}
      <div style={{ marginBottom: "20px" }}>
        <img
          src={isFront ? frontImage : backImage} // Display front or back image based on the toggle
          alt={isFront ? "Front of ID Card" : "Back of ID Card"}
          style={{
            width: "300px",
            height: "250",
            border: "1px solid #ccc",
            borderRadius: "8px",
            objectFit: "cover",
          }}
        />
        {documentType && <Box sx={{ textAlign: 'center', py: 1,display:'flex',gap:1,justifyContent:'center' }}>
          <Typography variant="body1" color="text.secondary" sx={{ textTransform: 'capitalize',fontWeight: 'bold', }}> Document Type:</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ textTransform: 'capitalize' }}> {documentType}</Typography>   
        </Box>}
          {documentNo && <Box sx={{ textAlign: 'center',display:'flex',gap:1,justifyContent:'center' }}>
          <Typography variant="body1" color="text.secondary" sx={{ textTransform: 'capitalize',fontWeight: 'bold', }}> Document Number:</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ textTransform: 'capitalize' }}> {documentNo}</Typography>   
        </Box>}
      </div>

      {/* Toggle buttons to switch between front and back images */}
      <div style={{ marginTop: "10px" }}>
        <button
          className="badge text-sm fw-medium border border px-20 py-12 radius-6"
          onClick={() => setIsFront(true)} // Show front image
          disabled={isFront} // Disable the button if already showing front
          style={{
            ...toggleButtonStyle,
            backgroundColor: isFront
              ? "var(--warning-100)"
              : "var(--neutral-100)",
            color: !isFront ? "var(--neutral-900)" : "var(--warning-900)",
          }}
        >
          Front
        </button>
        <button
          className="badge text-sm fw-medium border border px-20 py-12 radius-6"
          onClick={() => setIsFront(false)} // Show back image
          disabled={!isFront} // Disable the button if already showing back
          style={{
            ...toggleButtonStyle,
            backgroundColor: !isFront
              ? "var(--warning-100)"
              : "var(--neutral-100)",
            color: !isFront ? "var(--warning-900)" : "var(--neutral-900)",
          }}
        >
          Back
        </button>
      </div>
    </div>
  );
};

// Button styles
const uploadButtonStyle = {
  margin: "10px",
  padding: "10px 20px",
  cursor: "pointer",
  backgroundColor: "#007BFF",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
};

const toggleButtonStyle = {
  margin: "10px",
  padding: "10px 20px",
  cursor: "pointer",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
};

export default IDCardViewer; 
